import { environment } from "./environment.js";

class ServiceApi {

  async GetCo2Saving(shopId, productId) {
    const json = await fetch(`${environment.shopGateUrl}/utengine/co2saving/${shopId}/${productId}`);
    const result = await json.json();
    const response = {
      co2Saving: result.co2Saving,
      distanceSaving: result.distanceSaving,
    }
    return response;
  }

  async GetAlternativeProduct(shopId, variantId) {
    const result = await fetch(
      `${environment.shopGateUrl}/shop/alternativeproduct/${shopId}/${variantId}`
    );
    const response = await result.json();
    return response;
  }

  async GetSimilarProducts(shopId, variantId) {
    const result = await fetch(`${environment.shopGateUrl}/shop/similarproducts/${shopId}/${variantId}`);
    const response = await result.json();
    return response;
  }

  async GetPlacementsData(shopId) {
    // check if placements already exist in localStorage
    const ls = localStorage.getItem("uturn-placements");
    const storageData = JSON.parse(ls == "" || ls == null ? "{}" : ls);
    let response;

    // if the placements are in localStorage and are no older than 5 minutes return them
    if (storageData.date && Date.now() - storageData.date < 300000) {
      response = storageData;
      return response;
    }

    // fetch placements
    const result = await fetch(
      `${environment.shopGateUrl}/shop/placements/${shopId}`
    );
    response = await result.json();

    // save the placements in the localstorage
    const storageObject = {
      ...response,
      date: Date.now(),
    };
    localStorage.setItem("uturn-placements", JSON.stringify(storageObject));

    return response;
  }
}

export default ServiceApi;